export default __webpack_public_path__ + "static/media/Expert.f16235a1.jpg";